import { generateGUID } from '@awork/_shared/functions/guid-generator'

interface IChecklistItemTemplate {
  id: string
  name: string
  order: number
  createdOn?: Date
  updatedOn?: Date
  isNew?: boolean
}

export type ChecklistItemTemplates = ChecklistItemTemplate[]

export class ChecklistItemTemplate implements IChecklistItemTemplate {
  id: string
  name: string
  order: number
  createdOn?: Date
  updatedOn?: Date
  isNew?: boolean

  constructor(checklistItemTemplate: IChecklistItemTemplate) {
    Object.assign(this, checklistItemTemplate)
  }

  /**
   * Creates an empty checklistItem template
   * @param {number} length Current length of the checklistItems to create the new checklistItem at the end
   * @returns {ChecklistItemTemplate}
   */
  static empty(length: number): ChecklistItemTemplate {
    return new ChecklistItemTemplate({
      id: generateGUID(),
      name: '',
      order: length,
      isNew: true
    })
  }
}
